<template>
  <v-slide-y-transition mode="out-in">
    <div>
      <v-stepper :value="stepkeLocal" class="mt-0 pt-0">
        <v-stepper-header>
          <v-stepper-step :class="stepkeLocal === 1 ?'grey lighten-4':''" step="1" @click="backToStep(1)" :complete="stepke >= 1" :loading="true">Sign Up
            <v-progress-linear :indeterminate="true" v-if="loading[1]" class="ma-0" height="3"></v-progress-linear>
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :class="stepkeLocal === 2 ?'grey lighten-4':''" step="2" @click="backToStep(2)" :complete="status >= 2">Form Administrasi
            <v-progress-linear :indeterminate="true" v-if="loading[2]" class="ma-0" height="3"></v-progress-linear>
          </v-stepper-step>          
          <v-divider></v-divider>
          <v-stepper-step :class="stepkeLocal === 3 ?'grey lighten-4':''" step="3" @click="backToStep(3)" :complete="status >= 3">Pembayaran
            <v-progress-linear :indeterminate="true" v-if="loading[3]" class="ma-0" height="3"></v-progress-linear>
          </v-stepper-step>          
          <v-divider></v-divider>
          <v-stepper-step :class="stepkeLocal === 4 ?'grey lighten-4':''" step="4" @click="backToStep(4)" :complete="status >= 4">Angket Orang Tua
            <v-progress-linear :indeterminate="true" v-if="loading[4]" class="ma-0" height="3"></v-progress-linear>
          </v-stepper-step>          
          <v-divider></v-divider>
          <v-stepper-step :class="stepkeLocal === 5 ?'grey lighten-4':''" step="5" @click="backToStep(5)" :complete="status >= 5">Upload Berkas
            <v-progress-linear :indeterminate="true" v-if="loading[5]" class="ma-0" height="3"></v-progress-linear>
          </v-stepper-step>         
          <v-divider></v-divider>
          <v-stepper-step v-if="fm.tingkat_id > 1 && (fm.jalur_id == 1 || fm.jalur_id == 2) && !loadingData" :class="stepkeLocal === 6 ?'grey lighten-4':''" step="6" @click="backToStep(6)" :complete="status > 6">Tes Alquran & Ujian Online
            <v-progress-linear :indeterminate="true" v-if="loading[6]" class="ma-0" height="3"></v-progress-linear>
          </v-stepper-step>          
          <v-divider></v-divider>
          <v-stepper-step :class="stepkeLocal === 7 ?'grey lighten-4':''" step="7" @click="backToStep(7)" :complete="status >= 7">Pengumuman
            <v-progress-linear :indeterminate="true" v-if="loading[7]" class="ma-0" height="3"></v-progress-linear>
          </v-stepper-step>                    
        </v-stepper-header>
      </v-stepper>
      <template>
        <v-progress-linear class="ma-0 pa-0" :indeterminate="true" v-if="loadingData"></v-progress-linear>
      </template>
      <v-container class="pa-2 chat-drawer-container fluid grid-list-md">      
        <v-layout row wrap>
          <v-flex lg12 md12 sm12 xs12>
            <v-stepper :value="stepkeLocal" class="mt-0 pt-0">
              <v-stepper-items>
                <v-stepper-content step="1" class="pa-1">
                  <step1 :tingkat_id.sync="tingkat_id" :jalur_id.sync="jalur_id" :voucher.sync="voucher" :voucher_valid.sync="voucher_valid"></step1>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <template v-if="jalur_id==4">
                      <v-btn color="primary" v-if="voucher_valid || status >=2" class="pa-1" :loading="loading[2]" @click="stepke = 2">Selanjutnya</v-btn>
                      <v-btn color="primary" v-else class="pa-1" :disabled="true" :loading="loading[2]" @click="stepke = 2">Selanjutnya</v-btn>                      
                    </template>
                    <v-btn color="primary" v-else class="pa-1" :disabled="!tingkat_id || !jalur_id" :loading="loading[2]" @click="stepke = 2">Selanjutnya</v-btn>
                  </v-card-actions>                 
                </v-stepper-content>
                <v-stepper-content step="2" class="pa-0">
                  <step2 :tingkat_id.sync="tingkat_id" :jalur_id.sync="jalur_id" :voucher.sync="voucher" :stepke.sync="stepke"></step2>                                  
                </v-stepper-content>
                <v-stepper-content step="3" v-if="(status+1) >= 3" class="pa-1">
                  <step3 :stepke.sync="stepke" :loading="loading[4]"></step3>                                  
                </v-stepper-content>
                <v-stepper-content step="4" v-if="(status+1) >= 4" class="pa-1">
                  <step4 :stepke.sync="stepke"></step4>                                   
                </v-stepper-content>
                <v-stepper-content step="5" v-if="(status+1) >= 5" class="pa-1">
                  <step5 :stepke.sync="stepke"></step5>                           
                </v-stepper-content>
                <v-stepper-content step="6" class="pa-1">
                  <step6 :stepke.sync="stepke" :fm="fm" v-if="(status+1) >= 6" ></step6> 
                  <div v-else>
                    <v-alert type="info" :value="true">Maaf, Ananda belum menyelesaikan step sebelumnya.
                      <v-btn @click="stepke=5">Kembali</v-btn>
                    </v-alert>
                  </div>                                                                   
                </v-stepper-content>
                <v-stepper-content step="7" class="pa-1">
                  <step7 :stepke.sync="stepke"  v-if="(status) >= 7"></step7>                  
                  <div v-else>
                    <v-alert type="info" :value="true">
                      Maaf, Sekarang belum periode pengumuman. Info lebih lanjut hubungi admin.
                      <v-btn @click="backFromStep7()">Kembali</v-btn>
                    </v-alert>
                  </div>                                 
                </v-stepper-content>
              </v-stepper-items>                
            </v-stepper>
          </v-flex>
          <!--<v-flex lg3 md4 sm12 xs12>
            <v-card>
              <timeline></timeline>
            </v-card>
          </v-flex>-->
        </v-layout>        
      </v-container>
    </div>    
  </v-slide-y-transition>  
</template>
<script>
import User  from '@/util/models/User';
import Model from '@/models/dashboard';
import Timeline from './components/timeline';

const  model = new Model();

import Step1 from './pages/step1';
import Step2 from './pages/step2';
import Step3 from './pages/step3';
import Step4 from './pages/step4';
import Step5 from './pages/step5';
import Step6 from './pages/step6';
import Step7 from './pages/step7';

export default {
  components: {
    Timeline,
    Step1,Step2,Step3,Step4,Step5,Step6,Step7, 
  },
  data:()=>({
    user : User.attributes(),
    drawer : true,
    stepke : 1,
    stepkeLocal : 1,
    status : 1,
    loading : [false,false,false,false,false,false,false,false],
    firstime : true,
    fm : {},
    loadingData : true,
    tingkat_id: null,
    jalur_id: null,
    voucher: null,
    voucher_valid: false,
  }),
  watch:{
    stepke(newVal,oldVal){
      if(!newVal){
        return;
      }
      if(!this.firstime){
        this.loading[newVal] = true;              
      }      
      model.currentStatus().then((res)=>{
        if(res.status === 200){
          this.status = res.data;
          if(newVal > oldVal && newVal > this.status){
            this.backToStep(this.status+1);               
          }                                                  
        }                
        setTimeout(()=>{          
          this.loading[newVal] = false;  
          let tambahan = 0
          if(this.firstime && this.fm.tingkat_id > 1 && (this.fm.jalur_id == 1 || this.fm.jalur_id == 2)){
            tambahan = 1;
          }        
          this.firstime = false;
          this.stepkeLocal = newVal+tambahan; 
          console.log(this.stepkeLocal)
        }, 100);
      });      
      //console.log(newVal)
      this.fm = {};
      model.viewAdministrasi({id:this.user.id}).then(data=>{
        this.fm = data;
      });
    },    
  },
  computed: {    
               
  },  
  created(){
    
  },
  mounted(){    
  
    document.title = this.user.name;
    this.init();    
  },
  methods : {
    init(){
      this.loadingData = true;      
      model.viewAdministrasi({id:this.user.id}).then(data=>{
        Object.assign(this.fm, data);                        
        this.tingkat_id = this.fm.tingkat_id
        this.jalur_id   = this.fm.jalur_id
        this.voucher    = this.fm.voucher
        this.loadingData = false; 
        if(this.fm.gender){
          this.getCurrentStatus() 
        }        
      });      
    },

    getCurrentStatus(){
      model.currentStatus().then((res)=>{
        if(res.status === 200){
          this.status = res.data;          
          console.log(this.status)
          if(this.status == 1){
              this.stepke = 2
          } else if(this.status == 2) {
              this.stepke = 3
          } else {
              this.backToStep((this.status));
              setTimeout(()=>{
                let tambahan = 0;
                if(this.firstime && (this.stepke == 4 || (this.stepke == 5 && this.fm.tingkat_id > 1))){
                  tambahan = 1;                
                }
                this.stepkeLocal = this.stepke+tambahan;              
              }, 100);
          }
        }      
        this.loadingData = false;  
      });
    },

    initBiasa(){
      model.viewAdministrasi({id:this.user.id}).then(data=>{
        Object.assign(this.fm, data);                             
      });
    },

    backToStep(step){
      if(step <= this.status){    
        if(this.stepke == step){
          this.getDataStatus();
        } else {
          this.stepke = step;
        }                   
      }
    },

    getDataStatus(){
      if(!this.firstime){
        //this.loading[this.stepke] = true;              
      }      
      model.currentStatus().then((res)=>{
        if(res.status === 200){
          this.status = res.data;
          if( this.stepke > this.status+1){
            this.backToStep(this.status+1);               
          }                                                  
        }                
        setTimeout(()=>{          
          //this.loading[this.stepke] = false;  
          let tambahan = 0
          if(this.firstime && (this.stepke == 4 || (this.stepke == 5 && this.fm.tingkat_id > 1))){
            tambahan = 1;
          }        
          this.firstime = false;
          this.stepkeLocal = this.stepke+tambahan; 
        }, 100);
      });            
      this.fm = {};
      model.viewAdministrasi({id:this.user.id}).then(data=>{
        this.fm = data;
      });
    },

    backFromStep7(){
      if(this.fm){
        if(this.fm.tingkat_id > 1 && (this.fm.jalur_id == 1 || this.fm.jalur_id == 2)){
          this.stepke = 6
        } else {
          this.stepke = 5
        }
      }
    }
  }
};
</script>


